import React, { FC } from "react";
import {
  Typography,
  Chip,
  Card,
  CardActionArea,
  CardContent,
  Stack,
  Box,
  Zoom,
} from "@mui/material";
import Grid2 from "@mui/material/Unstable_Grid2";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

import {
  AccessibleBoard,
  switchState,
} from "../../features/player/playerSlice";
import { getTournoi } from "../../features/tournoi/tournoiSlice";

import { useAppDispatch, useAppSelector } from "../../store";

interface RegisterSelectBoardProps {
  board: AccessibleBoard;
}

export const RegisterSelectBoard: FC<RegisterSelectBoardProps> = (
  props: RegisterSelectBoardProps
) => {
  const dispatch = useAppDispatch();
  const tournoi = useAppSelector(getTournoi);
  const { board } = props;
  const player = useAppSelector((state) => state.player.player);
  const participation = player?.participation?.find(
    (p) => p.tableauId === board.id
  );
  const isCheckedIn = participation?.checkedIn;

  const titleTournementClosed = board.hasWaitingQueue
    ? tournoi?.boardClosedWithQueueLabel
    : tournoi?.boardClosedDefaultLabel;

  return (
    <Grid2 xs={12} sm={6} md={4}>
      <Zoom in>
        <Card
          elevation={6}
          sx={{
            flex: "1 1 300px",
            maxWidth: 350,
            width: "100%",
            minWidth: 0,
            opacity: board.disabled ? 0.5 : 1,
            pointerEvents: board.disabled ? "none" : "auto",
            backgroundColor:
              board.disabled && board.selected
                ? "warning.light"
                : board.disabled
                ? "grey.200"
                : board.selected
                ? "primary.main"
                : "background.paper",
            color: board.disabled
              ? "text.disabled"
              : board.selected
              ? "primary.contrastText"
              : "text.primary",
            borderRadius: 3,
            transition: "transform 0.3s ease",
            "&:hover": {
              transform: "scale(1.03)",
              boxShadow: 6,
            },
          }}
        >
          <CardActionArea
            onClick={() => dispatch(switchState(board.id))}
            disabled={board.disabled || isCheckedIn}
          >
            <CardContent sx={{ padding: 3 }}>
              <Stack spacing={1} direction="row" alignItems="center">
                {isCheckedIn && (
                  <Chip
                    label="Pointé"
                    color="success"
                    size="small"
                    icon={<CheckCircleIcon />}
                    sx={{ fontWeight: 600, zIndex: 2, marginRight: 1 }}
                  />
                )}
                <Typography variant="h6" fontWeight={600} sx={{ flexGrow: 1 }}>
                  Tableau {board.name}
                </Typography>
              </Stack>

              {(board.ferme || board.isFull) && (
                <Box>
                  <Chip
                    label={titleTournementClosed}
                    color="error"
                    size="small"
                    icon={<span style={{ fontSize: "1rem" }}>⛔</span>}
                    sx={{ fontWeight: 500 }}
                  />
                </Box>
              )}

              <Typography variant="body1">{board.label}</Typography>
              <Typography variant="body2" color="text.secondary">
                Heure limite de pointage : {board.heureLimite}
              </Typography>
            </CardContent>
          </CardActionArea>
        </Card>
      </Zoom>
    </Grid2>
  );
};
